import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  text: 'Die Stationen im Tomo 1 sind ein Traum. Kein Touristenstress, keine Schlangen, halber Preis. Ich habe das System allen Kollegen empfohlen.',
  name: 'Elena Zimmermann',
  role: 'HR-Managerin',
  city: 'Basel'
}, {
  text: 'Jeden Rappen wert. Der Alpine Identity Guide hat meinen Ski-Alltag in der Berghütte komplett verändert. Ich werde jetzt behandelt wie ein Einheimischer.',
  name: 'Sara Müller',
  role: 'Marketingexpertin',
  city: 'Genf'
}, {
  text: 'Auch meine Kinder mit unterschiedlichen Niveaus machen begeistert mit. Die Stationen sind inklusiv und anpassungsfähig. Ich empfehle es allen Familien.',
  name: 'Chiara Rossi',
  role: 'Mutter',
  city: 'Winterthur'
}, {
  text: 'Das GPS-Kompass-Material ist aussergewöhnlich. Ich finde immer kostenlose Parkplätze und Geheimzugänge, die ich vorher nie kannte.',
  name: 'Valentina Greco',
  role: 'Designerin',
  city: 'Luzern'
}, {
  text: 'Das Insider Pro System hat unseren Familientag gerettet. Die Kinder-Gratis-Stationen haben uns allein 120 CHF gespart. Wunderbar.',
  name: 'Laura Hofmann',
  role: 'Ärztin',
  city: 'St. Gallen'
}, {
  text: 'Endlich ein komplettes System von der Stationswahl bis zur Ausrüstung. Kohärent, progressiv und mit klaren Zielen. Eine Investition, die sich in wenigen Wochen auszahlt.',
  name: 'Roberto Ferrari',
  role: 'Ingenieur',
  city: 'Zug'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-14 px-4" data-id="element-259">
      <div className="max-w-xl mx-auto" data-id="element-260">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-261">
          <div className="flex justify-center mb-2" data-id="element-262">
            <span className="text-brand-gold font-black text-xs uppercase tracking-widest" data-id="element-263">
              ⭐ VERIFIZIERTE BEWERTUNGEN
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3" data-id="element-264">
            Was Skifahrer aus der ganzen Schweiz sagen
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-265">
            Von Zürich bis Lugano haben über 1.500 Residenten und Expats ihre
            Skisaison transformiert.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-266">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-card border border-white/5 p-5 rounded-2xl" data-id="element-267">
              <div className="flex items-center gap-2 mb-3" data-id="element-268">
                <div className="flex text-brand-gold" data-id="element-269">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-3.5 h-3.5 fill-current" data-id="element-270" />)}
                </div>
                <span className="inline-flex items-center gap-1 text-[11px] font-bold text-green-400" data-id="element-271">
                  <BadgeCheckIcon className="w-3.5 h-3.5" data-id="element-272" /> Verifiziert
                </span>
              </div>
              <p className="text-gray-300 text-sm font-medium italic mb-3 leading-snug" data-id="element-273">
                "{t.text}"
              </p>
              <div className="border-t border-white/10 pt-3 flex flex-wrap justify-between items-center gap-2" data-id="element-274">
                <span className="text-xs text-gray-400 font-medium" data-id="element-275">
                  <span className="font-bold text-brand-cream" data-id="element-276">{t.name}</span>,{' '}
                  {t.role} · 📍 {t.city}
                </span>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-sm text-gray-400 mt-6 font-medium" data-id="element-277">
          ⭐⭐⭐⭐⭐ · 4.9/5 · (+500 Bewertungen)
        </p>

        <div className="mt-8 text-center" data-id="element-278">
          <a href="#pricing" className="text-brand-orange font-bold hover:underline" data-id="element-279">
            🚀 JETZT DEM SWISS PEAK SYSTEM BEITRETEN — +1.500 INSIDER
          </a>
        </div>
      </div>
    </section>;
}